/* eslint-disable */
import React, { Component } from 'react';
import './cashFlowForecastingAccordion.css';

class NavListAccordionWrapper extends Component {
  constructor(props) {
    super(props);
    this.navList = document.getElementsByClassName("navAccDetails");
  }

  componentDidUpdate() {
    this.toggleActiveAccordion()
  }


  toggleActiveAccordion = () => {
    if ((this.props.open === 0 || this.props.open) && this.navList && this.navList.length) {
      if (this.navList[this.props.open]) {
        this.navList[this.props.open].nextElementSibling.className = "gdocs-display-block";
      }
    }
  }

  render() {
    return (
      <div className="nav-list-accordion-wrapper">
        {this.props.children}
      </div>
    )
  }
}

export default NavListAccordionWrapper



// WEBPACK FOOTER //
// ./src/components/common/CashFlowForecastingAccordion/cashFlowForecastingAccordion.js